import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2c73b5' // ecoplus blue
      },
      dark: {
        primary: '#2c73b5' // ecoplus blue
      }
    }
  }
});

export default vuetify;
